import { Alert, Box, Button } from '@mui/material';
import EmptyState from './EmptyState.jsx';
import ListPageSkeleton from './ListPageSkeleton.jsx';
import { apiErrorMessage } from '../utils/apiErrorMessage.js';

export default function AdminPageState({
  isLoading,
  isError,
  error,
  onRetry,
  isEmpty,
  emptyTitle,
  emptyDescription,
  emptyVariant = 'initial',
  emptyAction = null,
  skeletonFilterSlots = 2,
  skeletonRows = 8,
  children,
}) {
  if (isError) {
    return (
      <Alert
        severity="error"
        sx={{ mb: 2 }}
        action={onRetry ? <Button color="inherit" size="small" onClick={onRetry}>Réessayer</Button> : null}
      >
        {apiErrorMessage(error, 'Chargement impossible. Réessayez dans un instant.')}
      </Alert>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ py: 1 }}>
        <ListPageSkeleton filterSlots={skeletonFilterSlots} rows={skeletonRows} />
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <EmptyState
        variant={emptyVariant}
        title={emptyTitle}
        description={emptyDescription}
        action={emptyAction}
      />
    );
  }

  return children;
}
